import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
import { AppModule } from '../../utilities/app/app.module';
import { CommonService } from '../../services/common.service';
import { ApiService } from '../../services/api.service';
import { TreeNode } from 'primeng/api';
import { SearchComponent } from '../../components/search/search.component';
import { SearchService } from '../../components/search/search-service';
import { Router } from '@angular/router';
import { VideoPlayerComponent } from '../../components/video-player/video-player.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { BehaviorSubject, Subject } from 'rxjs';

type ProfileType = {
  givenName?: string;
  surname?: string;
  userPrincipalName?: string;
  id?: string;
};

interface LazyEvent {
  first: number;
  last: number;
}
@Component({
  selector: 'app-explore',
  standalone: true,
  imports: [
    LoadingIndicatorComponent,
    AppModule,
    SearchComponent,
    VideoPlayerComponent,
    ScrollingModule,
    InfiniteScrollModule,
  ],
  templateUrl: './explore.component.html',
  styleUrl: './explore.component.scss',
})
export class ExploreComponent implements OnInit {
  isHome = false;
  users: any;
  loading = true;

  loggedin_profile: any;
  video_content_data: any;
  loaded_players = 0;
  total_players = 0;

  loading_next_index = new BehaviorSubject<any>(false);

  constructor(
    public commonservice: CommonService,
    public searchService: SearchService,
    private router: Router
  ) {
    // let navigation = this.router.getCurrentNavigation();
    // if (navigation?.extras) {
    //     let extras_state = navigation?.extras.state
    //     if (extras_state && extras_state['explore_state']) {
    //         this.playable_content = extras_state['explore_state'];
    //     }
    // }
  }

  nodes!: TreeNode[];

  search_term: string = '';

  files: any = [];

  selected_corpora: string = 'All';

  all_files: any;

  ngOnInit() {
    this.commonservice.logged_in_user_details.subscribe((user_profile: any) => {
      this.loggedin_profile = user_profile;
    });

    this.searchService.is_search_clicked.subscribe((data: any) => {
      this.loading = true;
      this.get_list_files();
      if (JSON.stringify(this.commonservice.video_data) != '{}') {
        let my_key = Object.keys(this.commonservice.video_data);
        let keys_to_iterate = Math.min(
          12,
          this.commonservice.video_data?.length
        );
        let some_data: any = {};
        for (let i = 0; i < keys_to_iterate; i++) {
          some_data[my_key[i]] = this.commonservice.video_data[my_key[i]];
        }
        this.all_files = some_data;
        this.loading = false;
      }
    });

    // this.loading = true;
    // this.get_list_files();
    // this.all_files = this.commonservice.video_data?.slice(0, Math.min(12, this.commonservice.video_data?.length));
    // this.files = this.all_files;
  }

  // ngAfterViewInit() {


  // }

  ngOnChanges(simpleChange: SimpleChanges) {
    if (simpleChange['all_files']) {
      if (Object.keys(this.all_files).length == Object.keys(this.commonservice.video_data).length) {
        let loader = document.getElementById('current_loader')
        if (loader) {
          loader.getElementsByTagName('span')[0]?.remove();
        }
      }
    }
  }

  get_files(event: any) {
    this.files = this.get_all_corpora_files(event?.target.innerText);
  }

  get_values(item: any): any {
    let values = Object.values(item);
    this.total_players = values.length;
    this.totalRecords = values.length;
    return values;
    // return item.value;
  }

  get_content_data(url: any) {
    return { url: url };
  }

  video_player_options = {
    responsive: true,
    fluid: true,
    aspectratio: '3:4',
    controlBar: {
      pictureInPictureToggle: true,
      nativeControlsForTouch: true,
    },
  };

  add_activated(event: any) {
    this.selected_corpora = event?.target.innerText;
    let children = event?.target.parentElement.children;
    for (let i = 0; i < children.length; i++) {
      children[i].classList.remove('active');
      let sibling = children[i].children;
      if (sibling.length > 0) {
        sibling[0].classList.remove('pi-chevron-up');
        if (!Array.from(sibling[0].classList).includes('pi-chevron-down')) {
          sibling[0].classList.add('pi-chevron-down');
        }
      }
    }
    event?.target.classList.add('active');
    // if(event?.target.innerText!='All'){
    //     let file_names = this.get_all_corpora_files(event?.target.innerText);
    //     if(file_names.length>0){
    //         let ul = document.createElement('ul')
    //         ul.className = "inner-file-list-ul"
    //         event?.target.append(ul);
    //     }

    //     file_names.forEach((file_name:string)=>{
    //         let li =  document.createElement('li')
    //         li.className = "inner-file-list-li"
    //         li.textContent = file_name
    //         event?.target.children[1].append(li);
    //     })

    // }
    let sibling = event?.target.children;
    sibling[0].classList.add('pi-chevron-up');
    sibling[0].classList.remove('pi-chevron-down');
  }

  get_all_corpora_files(corpora_name: string) {
    if (corpora_name == 'All') {
      return this.all_files;
    } else {
      if (this.files.length != 0) {
        let index = this.all_files.filter(
          (item: any) => item.name == corpora_name
        );
        return index;
      } else {
        return [];
      }
    }
    // ['data-1', 'data-2', 'data-3']
  }

  get_list_files() {
    return this.commonservice.video_data;
  }

  search_clicked(event: any) {
    this.searchService.is_search_clicked.next(event);
    this.get_list_files();
  }

  set_search_terms(event: any) {
    this.searchService.all_search_terms = event;
  }

  get_search_term(search: any) {
    let output = '';
    if (search?.text_query) {
      output = search.text_query;
    }
    if (search.ocr_criterias?.length > 0) {
      output += ', ' + search.ocr_criterias.join(' ');
    }

    if (search.speech_criterias?.length > 0) {
      output += ', ' + search.speech_criterias.join(' ');
    }
    return output;
  }

  get_metadata(event: any) {
    console.log(event);
    const video = event.target;
    const id = video.id;
    const seekBar = document.getElementById(id);

    // Positions of markers in seconds.
    const positions = [3, 6.5, 7];

    // Add each marker to the #seekbar element.
    positions.forEach(function (position) {
      // Is position within range of the duration?
      if (position <= video.duration) {
        // Calculate position in percentage..
        const left = (position / video.duration) * 100 + '%';

        // ..create marker and give it the left value..
        const marker = document.createElement('div');
        marker.classList.add('bubles');
        marker.style.left = left;

        // ..and add the marker to the #seekbar.
        seekBar?.appendChild(marker);
      }
    });
    return event;
  }

  async play_video(video_name: any, item: any, corpora_name: any) {
    let url_array = item.url.split('#t=');
    let url = url_array[0];
    let time = url_array[1].split(',')[0];
    this.loading = true;

    this.loading = false;
    let playing_obj = {
      show: true,
      name: video_name,
      url: url,
      corpora_name: corpora_name,
      start_time: time,
    };

    // let my_data = await this.get_blob(url);
    // playing_obj.url = my_data;

    this.router.navigate(['/view_content'], {
      state: { playable_content: playing_obj },
    });
  }

  async get_blob(url: any) {
    let response = await fetch(url);
    let data = await response.blob();
    url = URL.createObjectURL(data);
    return url;
  }

  get_duration_from_url(url: any) {
    let time_seconds = url.split('t=')[1].split(',');
    let start_time = time_seconds[0];
    return this.commonservice.get_duration(start_time);
  }

  get_properties(item: any, index: any) {
    return {
      item: item,
      index: index,
    };
  }

  generate_id(index: any, file_name: any) {
    return (file_name + '_videojs_' + index).replaceAll(' ', '_');
  }

  generate_seekbar_id(index: any, file_name: any) {
    return 'custom_seekbar_' + this.generate_id(index, file_name);
  }

  handle_player_ready(player: any) {
    this.loaded_players = this.loaded_players + 1;
    if (this.loaded_players == this.total_players) {
      this.loading = false;
      this.loaded_players = 0;
      this.total_players = 0;
    } else {
      this.loading = true;
    }
  }

  rows_to_display_per_page: number = 10;
  first_item_index: number = 0;
  totalRecords: number = 0;

  onPageChange3(event: any) {
    this.first_item_index = event.first;
    this.rows_to_display_per_page = event.rows;
  }

  onScroll() {
    let current_index = Object.keys(this.all_files).length;
    this.loading_next_index.next(true);
    if (current_index < this.commonservice.video_data?.length) {
      let my_key = Object.keys(this.commonservice.video_data);
      let keys_to_iterate = Math.min(
        8,
        this.commonservice.video_data?.length - current_index
      );
      let some_data: any = {};
      for (let i = current_index; i < current_index + keys_to_iterate; i++) {
        some_data[my_key[i]] = this.commonservice.video_data[my_key[i]];
      }
      this.all_files = Object.assign(some_data, this.all_files);
      this.loading_next_index.next(true);
    } else {
      this.all_files = this.commonservice.video_data;
      this.loading_next_index.next(true);
    }

    if (Object.keys(this.all_files).length == Object.keys(this.commonservice.video_data).length) {
      let loader = document.getElementById('current_loader')
      if (loader) {
        loader.getElementsByTagName('span')[0]?.remove();
      }
    }
  }
  
  get_length(){
    if(!this.all_files) return 0
    return Object.keys(this.all_files).length
  }
}
